<mat-form-field appearance="outline" [class.readonly]="readonly">
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="optionCtrl" [placeholder]="placeholder">
    <mat-option>
      <ngx-mat-select-search
        [formControl]="optionFilterCtrl"
        [placeholderLabel]="searchLabel"
        [noEntriesFoundLabel]="noResults"
      >
      </ngx-mat-select-search>
    </mat-option>

    @for (option of filteredOptions | async; track option) {
      <mat-option [value]="option">
        {{ option.label }}
      </mat-option>
    }
  </mat-select>
  @if (optionCtrl.invalid && (optionCtrl.dirty || optionCtrl.touched)) {
    <mat-error> Campo obligatorio </mat-error>
  }
</mat-form-field>
